import { render, staticRenderFns } from "./BatchNotificationList.vue?vue&type=template&id=d2cfb9ac"
import script from "./BatchNotificationList.vue?vue&type=script&lang=js"
export * from "./BatchNotificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports